import { supabase } from '@/shared/supabase/client';
import type { ResultatEnvoi } from '../types';

/**
 * Prévenir le partenaire par e-mail qu'une étape lui revient (refusée ou
 * rouverte). L'envoi se fait côté serveur (functions/api/notifier.ts), avec la
 * session du bureau.
 *
 * Le geste du bureau a déjà eu lieu : un e-mail qui ne part pas ne l'annule pas.
 * On rend donc toujours un résultat, que l'écran affiche, plutôt qu'une erreur.
 */
export async function notifierPartenaire(etapeId: string): Promise<ResultatEnvoi> {
  const { data } = await supabase().auth.getSession();
  const jeton = data.session?.access_token;
  if (!jeton) return { statut: 'non-envoye', raison: 'Session expirée : e-mail non envoyé.' };

  let reponse: Response;
  try {
    reponse = await fetch('/api/notifier', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${jeton}` },
      body: JSON.stringify({ etapeId }),
    });
  } catch {
    return { statut: 'non-envoye', raison: 'Le service d’e-mails est injoignable.' };
  }
  let corps: unknown = null;
  try {
    corps = await reponse.json();
  } catch {
    /* Page d'erreur du proxy : message par défaut ci-dessous. */
  }
  const o = typeof corps === 'object' && corps !== null ? (corps as Record<string, unknown>) : {};
  if (reponse.ok && o.statut === 'envoye' && Array.isArray(o.destinataires)) {
    return {
      statut: 'envoye',
      destinataires: o.destinataires.filter((d): d is string => typeof d === 'string'),
    };
  }
  return {
    statut: 'non-envoye',
    raison:
      typeof o.raison === 'string'
        ? o.raison
        : typeof o.message === 'string'
          ? o.message
          : 'L’e-mail n’a pas pu être envoyé.',
  };
}
